import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import useQuotationRepository from "../../../../../../repository/emergency/useQuotationRepository";
import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import {Paper, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import {Info} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import useHelper from "../../../../../../use/useHelper";

export default function ({interventionId}) {
    const helper = useHelper();
    const interventionRepository = useInterventionRepository();
    const quotationRepository = useQuotationRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type Quotation */
    const quotation = quotationRepository.findOneById(intervention?.getQuotationId()).select();

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(intervention) || isNull(intervention.getQuotationId())) return;

        quotationRepository.findOneById(intervention.getQuotationId()).exec();
    }, [JSON.stringify(intervention)]);

    const getTaxedClientPrice = () => {
        return intervention.getClientPrice() * ((quotation.getVat() / 100) + 1);
    }

    if (isNull(quotation) || isNull(intervention)) return null;

    return (
        <Slide direction={"left"} in={true} timeout={500}>
            <Paper elevation={3}>
                <Box display="flex" alignItems={"center"} px={2} py={1}>
                    <Box display="flex" alignItems={"center"}>
                        <Info color={"warning"}/>
                    </Box>
                    <Box ml={1}>
                        <Typography display="inline">
                            Informez le sociétaire de son reste à charge de&nbsp;
                        </Typography>
                        <Typography display="inline" fontWeight={"bold"} color={"warning"}>
                            {helper.priceFormatter(getTaxedClientPrice())} € TTC&nbsp;
                        </Typography>
                        <Typography display="inline">
                            ({helper.priceFormatter(intervention.getClientPrice())} € HT)
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    )
}